import React from 'react'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  $DCprimaryColor,
  DcBreadcrumbs,
  DcDiv,
  DcFlexBox,
  DcIcon,
  DcText,
  PixelPageContainer,
  PixelTable,
  Section,
  SectionContent,
} from 'pixel-base'
import queryString from 'query-string'
import { getDiscrepantOrders } from 'utils/api-routes.util'

import DiscrepancyDetails from './components/DiscrepancyDetails'

const columns = [
  {
    dataKey: 'source_order_id',
    name: 'Order ID',
    sortable: true,
    selector: (row) => row.source_order_id || '--',
  },
  {
    dataKey: 'tracking_id',
    name: 'CN#',
    sortable: true,
    selector: (row) => row.tracking_id,
  },
  {
    dataKey: 'consignee',
    name: 'Consignee',
    sortable: true,
    selector: (row) => row.consignee || '--',
  },
  {
    dataKey: 'courier_delivery_status',
    name: 'Courier Status',
    sortable: true,
    selector: (row) => row.courier_delivery_status || '--',
  },
  {
    dataKey: 'ems_order_status',
    name: 'PixelOne Status',
    sortable: true,
    selector: (row) => row.ems_order_status || '--',
  },
  {
    dataKey: 'delivery_reconcile_status',
    name: '  Delivery Reconcile Status',
    sortable: true,
    selector: (row) => row.delivery_reconcile_status || '--',
  },
  {
    dataKey: 'payment_reconcile_status',
    name: 'Payment Reconcile Status',
    sortable: true,
    selector: (row) => row.payment_reconcile_status || '--',
  },
]

const breadcrumbs = [
  {
    name: 'Courier Reconciliation',
    active: false,
    link: '/payments/payments-courier-wise',
  },
  {
    name: 'Discrepant Orders',
    active: true,
  },
]

const CourierWiseDetail = () => {
  const [tableLoading, setTableLoading] = React.useState(true)
  const [showDetailModal, setShowDetailModal] = React.useState(false)
  const [detailId, setDetailId] = React.useState(null)
  const [courierList, setCourierList] = React.useState([])
  const [filters, setFilters] = React.useState<any>({
    page: 0,
    courier_id: 0,
    reconcile_status: '',
  })
  React.useEffect(() => {
    const params = queryString.parse(location.search)
    setFilters({
      ...filters,
      courier_id: params?.courier_id,
      reconcile_status: params?.reconcile_status,
      start_date: params?.start_date,
      end_date: params?.end_date,
    })
  }, [])

  React.useEffect(() => {
    if (filters.courier_id) getAllDiscrepantOrders()
  }, [filters])

  const getAllDiscrepantOrders = () => {
    setTableLoading(true)
    getDiscrepantOrders(filters).subscribe((res: any) => {
      setCourierList(res.response.data)
      setTableLoading(false)
    })
  }

  const onRowClicked = (row: any) => {
    setShowDetailModal(true)
    setDetailId(row.order_id)
  }

  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{ fontSize: '16px', padding: '8px 0px' }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>
      <PixelPageContainer style={{ padding: '0' }}>
        <Section style={{ padding: '20px' }}>
          <SectionContent>
            <PixelTable
              columns={columns}
              data={courierList}
              isSearchable={false}
              progressPending={tableLoading}
              onRowClicked={onRowClicked}
              highlightOnHover={true}
              pointerOnHover={true}
              fixedHeader={true}
              fixedHeaderScrollHeight="calc(100vh - 181px)"
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>

      <DcFlexBox
        zIndex="100"
        width="100%"
        height="100%"
        onClick={() => setShowDetailModal(false)}
        right={showDetailModal ? '0' : '-100%'}
        backgroundColor="rgba(46, 49, 74, 0.4)"
        opacity="1"
        position="absolute"
      ></DcFlexBox>

      <DcFlexBox
        zIndex="100"
        width="70%"
        height="100%"
        right={showDetailModal ? '0' : '-100%'}
        top="0"
        border="1px solid #e8e7ec"
        backgroundColor="#fff"
        padding="10px"
        position="absolute"
        flexDirection="column"
        style={{ transition: 'right 0.5s ease-in-out' }}
      >
        <DcFlexBox
          height="30px"
          width="100%"
          backgroundColor="#fff"
          padding="0 10px 10px 10px"
          justifyContent="space-between"
        >
          <DcDiv padding="0 10px 0 0">
            <DcText style={{ fontWeight: '700' }}>Details</DcText>
          </DcDiv>
          <DcDiv
            hoverStyle={{
              color: $DCprimaryColor,
              curser: 'pointer',
            }}
            color="rgba(0, 0, 0, 0.5)"
            width="15px"
          >
            <DcIcon
              onClick={() => {
                setShowDetailModal(false)
              }}
              color="inherit"
              height="50px"
              width="40px"
              fontSize="30px"
              icon={faXmark}
            />
          </DcDiv>
        </DcFlexBox>
        <DcDiv height="calc(100vh - 30px)">
          <DiscrepancyDetails
            filters={filters}
            detailId={detailId}
            setShowDetailModal={setShowDetailModal}
          />
        </DcDiv>
      </DcFlexBox>
    </>
  )
}

export default CourierWiseDetail
